import { render } from "./CustomHeader.vue?vue&type=template&id=e6318430&scoped=true"
import script from "./CustomHeader.vue?vue&type=script&lang=js"
export * from "./CustomHeader.vue?vue&type=script&lang=js"

import "./CustomHeader.vue?vue&type=style&index=0&id=e6318430&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6318430"]])

export default __exports__